import NetworkProvider from '../Provider';

const url = '/api/v1/verify/apple';

const verifyWithApple = async (code) => {
  const payload = {
    code,
  };
  return NetworkProvider().post(url, payload);
};

export default verifyWithApple;